module.exports = __webpack_public_path__ + "img/LS.18f44903.svg";